<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" lg="10" xl="8">
        <h1 class="text-h4">{{ $t('error.title') }} <small class="grey--text text--darken-1">404</small></h1>
        <v-card>
          <v-card-text>
            <v-row align="center">
              <v-col style="flex-grow:0">
                <v-icon color="red darken-4" style="font-size:3.5rem">fas fa-exclamation-triangle</v-icon>
              </v-col>
              <v-col class="pl-2">
                <span class="text-body-1">{{ $t('error.message404') }}</span>
              </v-col>
            </v-row>
            <div class="my-4 red--text">
              <code class="pa-3 d-block">{{ url }}</code>
            </div>
            <div class="grey--text">
              {{ datetime }}<br/>{{ userAgent }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  computed: {
    url () {
      return window.location.href;
    },
    datetime () {
      return new Date().toString();
    },
    userAgent () {
      return window.navigator.userAgent;
    },
    _pageTitle () {
      return this.$t('error.title');
    }
  }
};
</script>

<style scoped lang="scss">
code {
  word-break: break-all;
}
</style>
